export default __webpack_public_path__ + "static/img7-132cb29a2a149661e25af032e5be78e4.png";